export const EMAIL_INITIATION_METHODS = {
  AGENT_REPLY: 'AGENT_REPLY',
  OUTBOUND: 'OUTBOUND',
  TRANSFER: 'TRANSFER'
} as const;

// Caps how many GET /emails/content requests a single batch fires, so a large thread cannot
// burst parallel calls at Amazon Connect and trip its per-instance throttling.
export const PREVIOUS_EMAILS_BATCH_SIZE = 5;
